import { getAllPages, getBySlug } from 'utils/strapi'

import PageTitle from "components/layout/pageTitle"
import SEO from 'components/seo'
import dynamic from 'next/dynamic'
import { getFooterProps } from 'components/layout/footer'
import { getHeaderProps } from 'components/layout/header'
import { getLoaderProps } from 'components/loader'

const BlogList = dynamic(() => import('components/content/blog-list'));

export default function AuthorPage({ seoData, name, bio, blogs }) {
  return (
    <>
        <SEO {...seoData} />
        <PageTitle title={`<gradient>${name}<gradient>`} description={bio} />
        <BlogList blogs={blogs || []} />
    </>
  )
}

export async function getStaticProps(ctx) {
    const { params } = ctx;
    const result = await getBySlug("/api/authors", params.slug, {
        populate: {
            seo: {
                populate: '*',
                openGraphImage: {
                    populate: '*',
                }
            },
        }
    });
    if (!result) return {
        notFound: true,
    };
    const { seo, name, bio } = result.attributes;

    const blogs = await getAllPages("/api/blog-posts", {
        populate: ["thumbnailImage"],
        sort: ['publishedAt:desc'],
        filters: {
            author: {
                slug: {
                    $eq: params.slug
                }
            }
        }
    });

    return {
        props: {
            seoData: seo || null,
            name,
            bio,
            blogs,
            footerProps: await getFooterProps(),
            headerProps: await getHeaderProps(),
            loaderProps: await getLoaderProps(),
        }
    }
}

export async function getStaticPaths() {
    const authors = await getAllPages("/api/authors");
    return {
        paths: authors.map(author => ({ params: { slug: author.attributes.slug } })),
        fallback: 'blocking'
    };
}
